import React from 'react'
import { bool, number } from 'prop-types'
// import media from '../../../utils/style'
import styled, { css, keyframes } from 'styled-components'

const progressFill = keyframes`
from {
  transform: scaleX(0)
}
to {
  transform: scaleX(1)
}
`

const ProgressWrapper = styled.div`
  margin-top: -4px;
  height: 4px;
  background: ${(props) => props.theme.colors.white_op10};
  opacity: ${(props) => (props.playing ? 1 : 0)};
  transition: opacity 0.3s ease-out;
  position: relative;
  z-index: 1;
`
const ProgressFill = styled.div`
  height: 4px;
  background: ${(props) => props.theme.colors.blue};
  transform-origin: 0 0;
  animation: ${(props) =>
    props.playing
      ? css`
          ${progressFill} ${(props) => props.interval}ms forwards infinite
    linear
        `
      : 'none'};
`

export default function Progress(props) {
  const { interval, playing } = props
  return (
    <ProgressWrapper playing={playing}>
      <ProgressFill interval={interval} playing={playing} />
    </ProgressWrapper>
  )
}

Progress.propTypes = {
  interval: number,
  playing: bool
}
